/**
 * Tilbyr en blob til nettleseren som en nedlastet fil.
 *
 * Dette er sømmen mot nedlastings-mekanismen, på linje med `clipboard.ts`: en tynn
 * adapter hvis hele jobb er DOM-dansen blob -> `<a download>` -> click -> revoke.
 * Kallstedene (stores, composables, api-endepunkter, views) skal kalle denne og selv
 * asserte sitt eget utfall — filnavnet de valgte, innholdet de sendte, tilstanden de
 * satte — i stedet for å spionere på `URL.createObjectURL` og `document.body.appendChild`.
 *
 * Object-URL-en frigjøres alltid, også når klikket kaster (popup-blokkering), så en
 * feilet nedlasting ikke lekker minne. Ankeret fjernes i samme slengen — DOM-en er
 * uendret etterpå, uansett utfall.
 *
 * Historikk: dansen lå duplisert i elleve produksjonssteder med tre ulike staveformer
 * av URL-globalen (`URL`, `window.URL`, `globalThis.URL`), og var allerede uavhengig
 * trukket ut som `triggerBrowserDownload` to steder — begge med begrunnelsen «så testene
 * kan stubbe uten å trigge DOM». Denne modulen er den ene sømmen de to famlet etter (WI 3164).
 */
export function downloadBlob (blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}
